import { render, staticRenderFns } from "./PhotoComeDown.vue?vue&type=template&id=52285bb7&scoped=true&"
import script from "./PhotoComeDown.vue?vue&type=script&lang=js&"
export * from "./PhotoComeDown.vue?vue&type=script&lang=js&"
import style0 from "./PhotoComeDown.vue?vue&type=style&index=0&id=52285bb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52285bb7",
  null
  
)

export default component.exports